import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './BMSProjekte.css';

const typo3SitesMeta = [
  { name: 'AZ Direct', url: 'https://www.az-direct.com/site/' },
  { name: 'Bertelsmann Marketing Services', url: 'https://www.bertelsmann-marketing-services.com/' },
  { name: 'AZ Fundraising', url: 'https://www.az-fundraising.de/' },
  { name: 'Campaign Services', url: 'https://www.bms-campaign.de/de/' },
  { name: 'BMS IT', url: 'https://bertelsmann-marketing-services-it.com/' },
  { name: 'GGP Media', url: 'https://www.ggp-media.de/' },
  { name: 'MohnMedia', url: 'https://www.mohnmedia.de/' },
  { name: 'MohnMedia Azubiblog', url: 'https://www.azubiblog.mohnmedia.de/' },
  { name: 'Sonopress', url: 'https://www.sonopress.de/' },
  { name: 'Topac', url: 'https://www.topac.de/' },
  { name: 'Vogel-Druck', url: 'https://www.vogel-druck.de/' },
  { name: 'BPG USA', url: 'https://www.bpg-usa.com/' },
];

function BMSProjekte() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const typo3Sites = typo3SitesMeta.map((site, i) => ({
    ...site,
    desc: t.bms.siteDescs[i],
  }));

  return (
    <div className="bms-page">
      <button
        type="button"
        className="bms-back-button"
        onClick={() => {
          const scrollTo = location.state?.scrollTo || 'projects';
          navigate('/', { state: { scrollTo } });
        }}
      >
        {t.lebenslauf.back}
      </button>

      <h1>{t.bms.pageTitle}</h1>
      <div className="bms-meta">{t.bms.meta}</div>

      <div className="bms-description">
        <h2>{t.bms.roleTitle}</h2>
        <p>{t.bms.roleText}</p>
        <ul>
          <li>{t.bms.roleLi1}</li>
          <li>{t.bms.roleLi2}</li>
          <li>{t.bms.roleLi3}</li>
          <li>{t.bms.roleLi4}</li>
          <li>{t.bms.roleLi5}</li>
        </ul>
      </div>

      <div className="bms-div">
        <h2>{t.bms.typo3Title}</h2>
        <p className="bms-div__intro">{t.bms.typo3Intro}</p>
        <br />
        <div className="bms-grid">
          {typo3Sites.map((site) => (
            <a
              key={site.url}
              href={site.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bms-card"
            >
              <span className="bms-card__badge">TYPO3</span>
              <div className="bms-card__name">{site.name}</div>
              <div className="bms-card__desc">{site.desc}</div>
              <div className="bms-card__link">{t.bms.openSite}</div>
            </a>
          ))}
        </div>
      </div>

      <div className="bms-div">
        <br />
        <br />
        <h2>{t.bms.adalityTitle}</h2>
        <p className="bms-div__intro">{t.bms.adalityIntro}</p>
        <br />
        <div className="bms-grid bms-grid--narrow">
          <a
            href="https://adality.de/"
            target="_blank"
            rel="noopener noreferrer"
            className="bms-card"
          >
            <span className="bms-card__badge">Web</span>
            <div className="bms-card__name">Adality</div>
            <div className="bms-card__desc">{t.bms.adalityCardDesc}</div>
            <div className="bms-card__link">{t.bms.openSite}</div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default BMSProjekte;
